import type { OasWebPages } from '@ipfabric/utils';

export const DefaultOasWebPages = {
  inventory: [],
  technology: [],
  management: [],
  settings: [],
} satisfies OasWebPages;
